import React from 'react';
import { Helmet } from 'react-helmet';
import nsfwPlaceholder from './nsfw-placeholder.jpg';
import { strippedContent, escapeSpecialChars } from '../../lib/helpers';

const themas = [
  'dumpert_tv', 'straaljager', 'tfm', 'compilatie', 'fail', 'klassiekerts',
  'animatie', 'culinair', 'fapvoer', 'politiek', 'muziek', 'comedy',
  'bikini', 'liev', 'sport', 'cartoons', 'games', 'nerdshizzle',
];

export const ItemMetaTags = ({ item, url, embedded }) => {
  const description = escapeSpecialChars(strippedContent(item.description));
  const nsfw = item.nsfw;
  const type = item.media.length === 0 ? '' : 
    item.media[0].mediatype.toLowerCase()==='foto' ? 'image' : item.media[0].mediatype.toLowerCase();
  const appUrlArgument = `dumpert://${item.id}`;
  const tags = item.tags.split(' ');
  const categories = themas.filter(c => tags.includes(c));
  const secretItem = item.secret;
  const itemStill = stillType => item.nsfw ? nsfwPlaceholder : item.stills[stillType];

  return (
    <Helmet>
      <title>{`dumpert.nl - ${item.title}`}</title>
      <link rel="canonical" href={url.replace('//legacy.', 'https://www.')}/>
      {description && <meta name="description" content={description}/>}
      <meta name="dcterms.rights" content="MediaHuis Nederland B.V." />
      {/* eslint-disable-next-line max-len */}
      <link rel="license" href="https://www.mediahuis.nl/algemene-voorwaarden/gebruikersvoorwaarden-uitgaven/general-terms-of-use-for-mediahuis-publications/" />      
      {(nsfw || embedded || secretItem) && <meta name="robots"
        content="noindex, nofollow, noarchive, nosnippet, noodp, nocache"/>}
      <meta name="mediatype" content={type} />
      {tags.length > 0 && <meta name="keywords" content={tags.join(', ')} />}
      <meta property="og:title" content={item.title}/>
      <meta property="og:url" content={`https:${url}`}/>
      {description && <meta property="og:description" content={description}/>}
      <meta property="og:image" content={itemStill('still-large')} />
      {(type === 'video' && item.media.length > 0) && <meta name="og:video" content={item.media[0].variants[0].uri} />}
      {type === 'video' && <meta property="og:type" content={`${type}.other`}/> }
      {type !== 'video' && <meta property="og:type" content={type}/> }
      {tags.map(t => <meta property={`${type}:tag`} content={t} key={t}/>)}
      <meta name="twitter:site" value="@dumpert"/>
      <meta name="twitter:app:country" value="nl"/>
      <meta name="twitter:card" value="summary_large_image"/>
      <meta name="twitter:url" value={url}/>
      <meta name="twitter:title" value={item.title}/>
      {description && <meta name="twitter:description" value={description}/>}
      <meta name="twitter:image" value={itemStill('thumb-medium')} />
      <meta name="twitter:appidgoogleplay" value="nl.dumpert"/>
      <meta name="twitter:app:name:googleplay" value="Dumpert"/>
      <meta name="twitter:app:url:googleplay" value={url}/>
      <meta name="twitter:appidiphone" value="434815056"/>
      <meta name="twitter:app:name:iphone" value="Dumpert"/>
      <meta name="twitter:app:url:iphone" value={url}/>
      <meta name="twitter:widgets:theme" value="light"/>
      <meta name="twitter:widgets:link-color" value="#56af24"/>
      <meta name="twitter:widgets:border-color" value="#56af24"/>
      <meta property="al:ios:app_name" content="Dumpert"/>
      <meta property="al:ios:app_store_id" content="434815056"/>
      <meta property="al:ios:url" content={appUrlArgument}/>
      <meta property="al:android:app_name" content="Dumpert"/>
      <meta property="al:android:url" content={appUrlArgument}/>
      <meta property="al:android:package" content="nl.dumpert"/>
      <meta name="apple-itunes-app" content={`app-id=434815056, app-argument=${appUrlArgument}`} />
      {categories.length > 0 && <meta name="category" content={categories.join(',')} />}
      {type === 'video' && <meta name="cXenseParse:mhu-article_author" content="dumpert" />}
      {type === 'video' && <meta name="cXenseParse:mhu-article_ispaidcontent" content="false" />}
      {type === 'video' && tags.map(t => <meta name="cXenseParse:mhu-article_tag" content={t} key={t}/>)}
      {nsfw && <meta name="cXenseParse:Taxonomy" content="NSFW" />}
    </Helmet>
  );
};
